import { render, staticRenderFns } from "./ctcDashboardRates.vue?vue&type=template&id=2981c1f6"
import script from "./ctcDashboardRates.vue?vue&type=script&lang=js"
export * from "./ctcDashboardRates.vue?vue&type=script&lang=js"
import style0 from "./ctcDashboardRates.vue?vue&type=style&index=0&id=2981c1f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports